/** @jsxImportSource preact */
import { h } from 'preact';
import { CategoryBarChart, getChartController as getController } from './CategoryBarChart';
import { RISK_SUBDOMAIN_CONFIG } from '@/data/chartConfigs';
import type { StackByOption } from './FilterControls';
import type { ViewMode } from './ViewModeToggle';

// Re-export types and controller for backward compatibility
export type { ChartController } from './CategoryBarChart';
export const getChartController = getController;

interface RiskSubdomainChartProps {
  apiBase: string;
  containerId: string;
  initialFilters?: Record<string, string>;
  initialStackBy?: StackByOption;
  initialViewMode?: ViewMode;
}

export function RiskSubdomainChart({
  apiBase,
  containerId,
  initialFilters,
  initialStackBy,
  initialViewMode,
}: RiskSubdomainChartProps) {
  return (
    <CategoryBarChart
      config={RISK_SUBDOMAIN_CONFIG}
      apiBase={apiBase}
      containerId={containerId}
      initialFilters={initialFilters}
      initialStackBy={initialStackBy}
      initialViewMode={initialViewMode}
    />
  );
}
